import { CarouselApp } from "@/components/CarouselApp";
import { permanentSample } from "@/lib/sample";

export default function SamplePage() {
  return <CarouselApp initialPreview={permanentSample} sampleMode />;
}
